export type WebsiteRequestStatus = 'pending' | 'completed';

export type WebsiteRequest = {
  type?: string | null;
  label?: string | null;
  status?: WebsiteRequestStatus | string | null;
  receivedAt?: any;
  completedAt?: any;
  completedBy?: string | null;
};

export type WebsiteRequestKind =
  | 'general-enquiry'
  | 'schedule-site-visit'
  | 'request-brochure'
  | 'callback-request'
  | 'investor-bulk-booking';

export type WebsiteRequestConfig = {
  kind: WebsiteRequestKind;
  label: string;
  shortLabel: string;
  color: 'info' | 'warning' | 'success';
  priority: boolean;
};

const REQUEST_CONFIGS: Record<WebsiteRequestKind, WebsiteRequestConfig> = {
  'general-enquiry': {
    kind: 'general-enquiry',
    label: 'General Enquiry',
    shortLabel: 'General Enquiry',
    color: 'info',
    priority: false,
  },
  'schedule-site-visit': {
    kind: 'schedule-site-visit',
    label: 'Schedule a Site Visit',
    shortLabel: 'Visit Requested',
    color: 'warning',
    priority: false,
  },
  'request-brochure': {
    kind: 'request-brochure',
    label: 'Request Brochure',
    shortLabel: 'Brochure Requested',
    color: 'success',
    priority: false,
  },
  'callback-request': {
    kind: 'callback-request',
    label: 'Call Back Requested (WhatsApp)',
    shortLabel: 'Call Back Requested',
    color: 'warning',
    priority: true,
  },
  'investor-bulk-booking': {
    kind: 'investor-bulk-booking',
    label: 'Investor / Bulk Booking',
    shortLabel: 'Investor Lead',
    color: 'warning',
    priority: true,
  },
};

export function normalizeWebsiteRequestKind(value: unknown): WebsiteRequestKind {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (normalized.includes('brochure')) return 'request-brochure';
  if (normalized.includes('callback request') || normalized.includes('call back')) {
    return 'callback-request';
  }
  if (normalized.includes('site visit') || normalized.includes('schedule visit')) {
    return 'schedule-site-visit';
  }
  if (normalized.includes('investor') || normalized.includes('bulk booking')) {
    return 'investor-bulk-booking';
  }
  return 'general-enquiry';
}

export function websiteRequestConfig(value: unknown): WebsiteRequestConfig {
  return REQUEST_CONFIGS[normalizeWebsiteRequestKind(value)];
}

